import { Environment } from '@interfaces/Environment';

export const environment: Environment = {
  production: false,
  useAuth: true,
  useMocks: false,
  mockDelay: 0,
  backendBaseUrl: 'https://backend-api-uthyrningslagen-dev.azurewebsites.net',
};
